/*
* @Author: jack
* @Date:   2020-01-08 21:00:00
* @Last Modified by:   jack
* @Last Modified time: 2021-09-07 14:55:02
*/
import request from '@/utils/request'


export function getUserInfo(data) {
  return request({
    url: 'acitvity/dati/user/info',
    method: 'post',
    data
  })
}
export function getDatiQuestionInfoJingfang(data) {
  return request({
    url: 'acitvity/dati/question/info',
    method: 'post',
    data
  })
}
export function datiStore(data) {
  return request({
    url: 'acitvity/dati/question/store',
    method: 'post',
    data
  })
}
export function datiShare(data) {
  return request({
    url: 'acitvity/dati/question/sharee',
    method: 'post',
    data
  })
}
export function getResultInfo(data) {
  return request({
    url: 'acitvity/dati/question/result',
    method: 'post',
    data
  })
}
export function getRank(data) {
  return request({
    url: 'acitvity/dati/question/rank',
    method: 'post',
    data
  })
}
export function getRankAll(data) {
  return request({
    url: 'acitvity/dati/question/rankAll',
    method: 'post',
    data
  })
}
export function getRedbagInfo(data) {
  return request({
    url: 'acitvity/dati/question/redbag',
    method: 'post',
    data
  })
}
export function sendRedbag(data) {
  return request({
    url: 'acitvity/dati/question/send/redbag',
    method: 'post',
    data
  })
}
export function setUserInfo(data) {
  return request({
    url: 'acitvity/dati/user/save',
    method: 'post',
    data
  })
}
export function Jiang(data) {
  return request({
    url: 'acitvity/dati/question/jiang',
    method: 'post',
    data
  })
}

  export function JiangLog(data) {
  return request({
    url: 'acitvity/dati/question/jiangLog',
    method: 'post',
    data
  })
}
